import { ApolloClient, createHttpLink } from '@apollo/client'
import { InMemoryCache, NormalizedCacheObject } from '@apollo/client/cache'
import { MockLink } from '@apollo/client/testing'
import { createNetworkStatusNotifier } from 'react-apollo-network-status'

const schedulerApiUri = import.meta.env.VITE_SCHEDULER_API_GQL_URI

let schedulerClient: ApolloClient<NormalizedCacheObject>

const { link: statusLink, useApolloNetworkStatus } = createNetworkStatusNotifier()

export const useSchedulerNetworkStatus = useApolloNetworkStatus

const getSchedulerClient = (prevClient: ApolloClient<object>) => {
  // lame, but needed to have any proper testing right now.
  // MockedProvider's client will get overriden during tests unless
  // we check for any mocks
  if (prevClient.link instanceof MockLink) {
    return prevClient
  }

  if (schedulerClient) {
    return schedulerClient
  }

  const http = createHttpLink({
    uri: schedulerApiUri
  })

  const link = statusLink.concat(http)
  const cache = new InMemoryCache({
    typePolicies: {
      Environment: {
        keyFields: [],
        fields: {
          publicSettings: {
            merge(existing, incoming, { mergeObjects }) {
              // avoid warnings due to settings being a singleton
              return mergeObjects(existing, incoming)
            }
          }
        }
      }
    }
  })

  schedulerClient = new ApolloClient({ link, cache })

  return schedulerClient
}

export default getSchedulerClient
